export type SortOrderItem = {
  id: number;
  sortOrder: number;
};

export type SortOrderPatch = {
  id: number;
  sortOrder: number;
};

export function getNextSortOrder(items: Array<{ sortOrder: number }>): number {
  if (items.length === 0) {
    return 1;
  }
  return Math.max(...items.map((item) => item.sortOrder)) + 1;
}

export function getSortOrderPatches(
  original: SortOrderItem[],
  startIndex: number,
  endIndex: number,
): SortOrderPatch[] {
  const copyData = [...original];
  const deleted = copyData.splice(startIndex, 1);
  copyData.splice(endIndex, 0, ...deleted);

  const min = Math.min(startIndex, endIndex);
  const max = Math.max(startIndex, endIndex);
  const patches: SortOrderPatch[] = [];

  for (let i = min; i <= max; i++) {
    const reorderedItem = copyData[i];
    const originalItem = original[i];

    if (!reorderedItem || !originalItem) {
      continue;
    }

    const newSortOrder = originalItem.sortOrder;

    if (reorderedItem.sortOrder !== newSortOrder) {
      patches.push({ id: reorderedItem.id, sortOrder: newSortOrder });
    }
  }

  return patches;
}

/** Map backend pipe codes for instrument track/step writes. */
export function mapInstrumentWriteError(error: unknown, fallbackKey: string): string {
  const body =
    (error as { response?: { data?: unknown } })?.response?.data ??
    (error as { data?: unknown })?.data ??
    (error as { message?: string })?.message;

  const raw = typeof body === 'string' ? body : body != null ? String(body) : '';
  const code = raw.split('|')[0]?.trim() ?? '';

  if (code === 'instrument-step-not-allowed-for-mode') {
    return 'editor-instr-error-step-not-allowed';
  }
  if (code === 'instrument-track-mode-not-patchable') {
    return 'editor-instr-mode-fixed-hint';
  }
  return fallbackKey;
}

export function isMappedInstrumentWriteError(key: string): boolean {
  return (
    key === 'editor-instr-error-step-not-allowed' || key === 'editor-instr-mode-fixed-hint'
  );
}
